export const downloadFile = (
  csvContent: string,
  filename: string,
  type: string,
) => {
  const blob = new Blob([csvContent], { type });
  const link = document.createElement("a");

  link.setAttribute("href", URL.createObjectURL(blob));
  link.setAttribute("download", filename);

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
};
